module.exports = __webpack_public_path__ + "static/11-b0dd90e2b69f0d69f5fa2349f294a578.jpg";